import {classNames, React, useLocalStore, observer, stringify} from '@api'
import {DeterminateProgressBar} from '@modules/common/components/DeterminateProgressBar'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'

import {action, computed} from 'mobx'
import * as css from './SyncProgressBar.css'

class MyStore extends VipLocalStore {
  constructor(stores: StoresInstance,public id: string) {
    super(stores)
    const {syncProgress} = this
    if (!syncProgress.byId.has(id)) {
      syncProgress.byId.set(
        id,
        { })
    }
  }

  @computed get status() {
    return this.syncProgress.byId.get(this.id)
  }
}

export const SyncProgressBar = observer<{ className?: string, id: string }>( function SyncProgressBar({className, id}) {
  const store = useVipLocalStore((ws) => new MyStore(ws, id)),
    {status} = store

  return <div className={classNames(className, css.root)} data-show={status?.show === true}>
	  <DeterminateProgressBar showProgressBar={status?.show} percentage={status?.percent} progressBarType="linear"/>
  </div>
})



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/SyncProgressBar.tsx